import { useEffect, useState } from "react";
import EditarBannerCategoria from "./EditarBannerCategoria/EditarBannerCategoria";
import CriarBannerCategoria from "./CriarBannerCategoria/CriarBannerCategoria";
import "./AdminBannerCategoria.css";

function AdminBannerCategoria({
    banners,
    onClose,
    atualizarBanners
}) {
    const [bannerEditando, setBannerEditando] =
        useState(null);
    const [abrirCriar, setAbrirCriar] =
        useState(false);


    const [categorias, setCategorias] =
        useState([]);

    useEffect(() => {
        carregarCategorias();
    }, []);

    const carregarCategorias =
        async () => {
            try {
                const response =
                    await fetch(
                        "https://app.eliandroalimentos.com.br/api/categorias/listargrupos"
                    );

                const data =
                    await response.json();
                console.log("categorias", data)
                setCategorias(data);
            } catch (error) {
                console.error(error);
            }
        };


    const handleDeletarBanner =
        async (id) => {
            const confirmar =
                window.confirm(
                    "Deseja remover este banner?"
                );

            if (!confirmar) return;

            try {
                const response =
                    await fetch(
                        `https://app.eliandroalimentos.com.br/api/home_media/deletarbanner/${id}`,
                        {
                            method: "DELETE",
                        }
                    );

                const data =
                    await response.json();

                if (!response.ok) {
                    throw new Error(
                        data.message ||
                        "Erro ao deletar banner"
                    );
                }

                await atualizarBanners?.();
            } catch (error) {
                console.error(error);

                alert(
                    error.message ||
                    "Erro ao deletar banner"
                );
            }
        };

        const categoriasDisponiveis =
    categorias.filter((categoria) =>
        !banners.some(
            (banner) =>
                Number(banner.ordem) ===
                Number(categoria.codgrupo)
        )
    );


    return (
        <div className="adminBannerCategoria-container">
            <div className="adminBannerCategoria-header">
                <h2>
                    Banners de Categorias
                </h2>
<button
        className="adminBannerCategoria-add"
        onClick={() =>
            setAbrirCriar(true)
        }
    >
        Add Categoria
    </button>
                
            </div>

<div className="adminBannerCategoria-header-acoes">
    

    
</div>

            <div className="adminBannerCategoria-lista">
                {banners.map((banner) => {
                    const categoria =
                        categorias.find(
                            (c) =>
                                Number(c.codgrupo) ===
                                Number(banner.ordem)
                        );

                    return (
                        <div
                            key={banner.id}
                            className="adminBannerCategoria-item"
                        >
                            <span className="adminBannerCategoria-ordem">
                                {banner.ordem}
                            </span>

                            <span className="adminBannerCategoria-nome">
                                {categoria?.descricao ||
                                    "Categoria não encontrada"}
                            </span>

                            <button
                                className="adminBannerCategoria-editar"
                                onClick={() =>
                                    setBannerEditando(banner)
                                }
                            >
                                Editar
                            </button>

                            <button
                                className="adminBannerCategoria-deletar"
                                onClick={() =>
                                    handleDeletarBanner(
                                        banner.id
                                    )
                                }
                            >
                                ✕
                            </button>
                        </div>
                    );
                })}
            </div>
            {bannerEditando && (
                <EditarBannerCategoria
                    banner={bannerEditando}
                    onClose={() =>
                        setBannerEditando(null)
                    }
                    onSalvar={() => {
                        atualizarBanners?.();
                        setBannerEditando(null);
                    }}
                />
            )}

            {abrirCriar && (
    <CriarBannerCategoria
        categorias={
            categoriasDisponiveis
        }
        onClose={() =>
            setAbrirCriar(false)
        }
        onSalvar={() => {
            atualizarBanners?.();
            setAbrirCriar(false);
        }}
    />
)}
        </div>
    );
}

export default AdminBannerCategoria;